export default __webpack_public_path__ + "static/media/Logotip_white.547c7f23.svg";